export default __webpack_public_path__ + "static/study-cafe2-85d94d3161ba3b6904200b11de8f9fd8.jpg";